import React from 'react';

import InputMask from './InputMask';

const InputPhone = React.forwardRef(
    (props, ref) => {

        return (
            <InputMask
                mask={'(00) 0000-0000'}
                {...props}
                ref={ref}
            />
        );
    });
export default InputPhone;
